import Phaser from "phaser";

export default class CreditsScene extends Phaser.Scene {
  constructor() {
    super({ key: "CreditsScene" });
  }

  create(): void {
	window.resetGame();
    
	this.text = this.add.text(window.innerWidth/2, window.innerHeight/2, [
		"  Narrator:",
		"  Woooah. That was a really epic and bloody fight. Fortunately you"
		"  were able to kill professor Quirkelfox and to thwart his evil plans.  ",
		"  The world is now a better place.",
		"",
		"  Thank you for playing our game!",
		"",
		"  Credits:",
		"  Jaime Oliveira"
		"  Michael Vogel"
		"  Matthias Vogel"
		"  Sabrina Hippchen"
		"  Patrick Bender"
		"  Marius Ferrang"
		"  Thomas Stuppy"
	], {
      fontFamily: "sans-serif",
      color: "#ffffff",
	  fontSize: 20
    });
	this.text.setOrigin(0.5);
  }
  
  update(time: number, delta: number) {
	
  }
}
